import plugin from "tailwindcss/plugin.js";
import { config } from "./config";

export default plugin(
  // plugin
  () => {},
  // config
  config,
);
